export default __webpack_public_path__ + "static/media/mini-nombre.90e379ca.png";